import { theme } from '@factorialco/deprecated-design-system'
import { ThemeAPI } from 'nuvo-react'

export const joinSheet: ThemeAPI['joinSheet'] = {
  joinPopover: {
    backgroundColor: theme.colors.grey800,
    color: theme.colors.white,
  },
  sheetPreview: {
    sheetName: {
      color: theme.colors.radicalRed600,
    },
  },
  sheetSelection: {
    badge: {
      backgroundColor: theme.colors.radicalRed100,
      color: theme.colors.radicalRed600,
    },
    sheet: {
      title: {
        color: theme.colors.radicalRed600,
      },
      description: {
        color: theme.colors.grey800,
      },
    },
  },
  table: {
    badge: {
      backgroundColor: theme.colors.grey300,
      border: theme.colors.grey300,
      color: theme.colors.iconPrimary,
    },
  },
  appendColumnsDialog: {
    dropdown: {
      selectedOption: {
        backgroundColor: theme.colors.grey200,
      },
      header: {
        backgroundColor: theme.colors.grey200,
        color: theme.colors.grey800,
      },
    },
  },
  joinColumnsDialog: {
    dropdown: {
      selectedOption: {
        backgroundColor: theme.colors.grey200,
      },
      header: {
        backgroundColor: theme.colors.grey200,
        color: theme.colors.grey800,
      },
    },
    matchStatus: {
      success: {
        percent: {
          color: theme.colors.positiveBackgroundSolid,
        },
        icon: {
          color: theme.colors.positiveBackgroundSolid,
        },
        root: {
          backgroundColor: theme.colors.grey000White,
        },
        description: {
          color: theme.colors.grey600,
        },
      },
      warning: {
        percent: {
          color: theme.colors.warningBackgroundSolid,
        },
        icon: {
          color: theme.colors.warningBackgroundSolid,
        },
        root: {
          backgroundColor: theme.colors.grey000White,
        },
        description: {
          color: theme.colors.grey600,
        },
      },
    },
  },
}
